module.exports = __webpack_public_path__ + "static/media/image4.9f6e33bf.png";